<template>
  <div class="form-group m-0">
    <div   class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : value, 'bootstrap-switch-off bootstrap-switch-focused' : !value }">
      <div class="bootstrap-switch-container"  @click.stop="toggleValue">
        <span  :id="`${id}-on`" class="bootstrap-switch-handle-on bootstrap-switch-primary">yes</span>
        <span  class="bootstrap-switch-label"></span>
        <span :id="`${id}-off`"  class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitchControl',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    id: { // New prop for the ID
      type: String,
      default: null // Or make it required if a label always needs it
    }
  },
  methods: {
    toggleValue() {
      this.$emit('change', !this.value);
    }
  }
};
</script>
